import React from 'react';
import ReactDOM from 'react-dom/client';
import './ui/css/index.css';
import {Navigation} from "./ui/components/Navigation";
import {Title} from "./ui/pages/Title";
import {LeftBar} from "./ui/components/LeftBar";
import {RightBar} from "./ui/components/RightBar";
import {About} from "./ui/pages/About";
import {Introduction} from "./ui/pages/Introduction";
import {Token} from "./ui/pages/Token";
import {RoadMap} from "./ui/pages/RoadMap";
import {Footer} from "./ui/components/Footer";
import {Provider} from "react-redux";
import {Store} from "./app/Store";
import {Common} from "./app/Common";
import {FAQ} from "./ui/pages/FAQ";

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<Provider store={Store}>
			<Navigation/>
			<Title/>
			{!Common.isMobile && <LeftBar/>}
			{!Common.isMobile && <RightBar/>}
			<About/>
			<Introduction/>
			<Token/>
			<RoadMap/>
			<FAQ/>
			<Footer/>
		</Provider>
	</React.StrictMode>
)
